// A consistent, gentle camera move across browsers. Native smooth scrolling
// chooses its own duration and can finish before the turn's visual handoff.
export function animateScroll(from, to, update, duration = 1000) {
  let frame;
  let cancelled = false;
  const started = performance.now();
  const tick = now => {
    if (cancelled) return;
    const progress = Math.min(1, Math.max(0, (now - started) / duration));
    const eased = progress * progress * (3 - 2 * progress);
    update(progress === 1 ? to : from + (to - from) * eased);
    if (progress < 1) frame = requestAnimationFrame(tick);
  };
  frame = requestAnimationFrame(tick);
  return () => {
    cancelled = true;
    cancelAnimationFrame(frame);
  };
}
